import { useContext } from 'react'
import { DataContext } from '../context/DataContext'

export const useSteps = () => {
  const { steps, setSteps, currentStep, setCurrentStep, setPointsData, isPickup, setCartData } = useContext(DataContext)

  const markCurrentStepAsCompleted = () => {
    const updatedSteps = [...steps]
    updatedSteps[currentStep - 1].completed = true
    // Substeps also
    if (updatedSteps[currentStep - 1].subSteps) {
      updatedSteps[currentStep - 1].subSteps.forEach((subStep) => {
        subStep.completed = true
      })
    }
  }

  const goToNextStep = () => {
    // Mark current step as completed
    markCurrentStepAsCompleted()
    // Move to next step
    setCurrentStep(currentStep + 1)
  }

  const goBackToStepOne = () => {
    const updatedSteps = [...steps]
    updatedSteps[0].completed = false
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = false
    updatedSteps[1].subSteps[1].completed = false
    setSteps(updatedSteps)
    setCurrentStep(1)
  }

  const goBackToStepTwo = () => {
    const updatedSteps = [...steps]
    updatedSteps[1].completed = false
    updatedSteps[1].disabled = false
    if (isPickup) {
      setPointsData((prevState) => {
        prevState.localPointSelected = {}
        prevState.pinflagPointSelected = {}
        return prevState
      })
    } else {
      updatedSteps[1].subSteps[0].completed = true
      updatedSteps[1].subSteps[1].completed = false
      updatedSteps[1].subSteps[2].completed = false
    }
    setSteps(updatedSteps)
    setCartData((prevState) => ({
      ...prevState,
      shippingCost: null
    }))
    setCurrentStep(2)
  }

  const forceDeliveryMethodSelection = () => {
    const updatedSteps = [...steps]
    updatedSteps[1].completed = false
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    updatedSteps[1].subSteps[1].completed = false
    updatedSteps[1].subSteps[2].completed = false
    setSteps(updatedSteps)
    setCurrentStep(2)
  }

  const goToPreviousStep = () => {
    if (currentStep === 2) {
      goBackToStepOne()
    }
    if (currentStep === 3) {
      goBackToStepTwo()
    }
  }

  const markDeliveryStepAsCompleted = () => {
    const newSteps = steps.map((step, index) => {
      if (index === 1) {
        return {
          ...step,
          completed: true,
          disabled: false,
          subSteps: step.subSteps.map((subStep) => {
            return {
              ...subStep,
              completed: true
            }
          })
        }
      }
      return step
    })
    setSteps(newSteps)
  }

  const goToPurchaseOrderConfirmation = () => {
    const purchaseOrderConfirmationStep = 4
    setStepsDoneAfterSucessfulPayment()
    setCurrentStep(purchaseOrderConfirmationStep)
  }
  const setStepsDoneAfterSucessfulPayment = () => {
    // Mark all steps and substeps as completed
    const newSteps = steps.map((step) => {
      return {
        ...step,
        completed: true,
        subSteps: step.subSteps.map((subStep) => {
          return {
            ...subStep,
            completed: true
          }
        }),
        disabled: true
      }
    })
    setSteps(newSteps)
  }

  return {
    setStepsDoneAfterSucessfulPayment,
    goToNextStep,
    goToPreviousStep,
    markDeliveryStepAsCompleted,
    goToPurchaseOrderConfirmation,
    forceDeliveryMethodSelection
  }
}
